import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ReportsService {

  constructor(private http: HttpClient) { }

  // getCalendarEvents(clientId: any): Observable<any> {
  //   return this.http.get('/getCalendarEvents', { params: { clientcode: clientId } });
  // }

  getCalendarEvents(clientId: any, fromDate: any, toDate: any): Observable<any> {
     return this.http.get('/getCalendarEvents', { params: { clientcode: clientId, from: fromDate, to: toDate}});
  }

  addCalendarEvent(event: any): Observable<any> {
    return this.http.post('/calendarEvent', event);
  }

  updateCalendarEvent(event: any): Observable<any> {
    return this.http.post('/calendarEvent', event);
  }

  deleteCalendarEvent(event: any): Observable<any> {
    return this.http.post('/calendarEvent', event);
  }

  getledger(formData: any): Observable<any> {
    return this.http.post('/ledger', formData);
  }

  getEligibleScripData(clientId: any): Observable<any> {
    return this.http.get('/getEligibleScrips', { params: { clientcode: clientId } });
  }

  getHoldingData(clientId: any): Observable<any> {
    return this.http.get('/getHoldingsData', { params: { clientcode: clientId } });
  }

  getHoldingDataEquity(date: any): Observable<any> {
    return this.http.get('/getHoldingsDataTable', { params: { as_on_date: date } });
  }

  getTags(pageName: any): Observable<any> {
    return this.http.get('/tagsGet', { params: { page_name: pageName } });
  }


  getPerformancePortfolio(params:any):Observable<any> {
    return this.http.get(`/performancePortfolio`,{params});
  }

  getHoldingDataMcx(clientId: any): Observable<any> {
    return this.http.get('/getHoldingsDataMcx', { params: { clientcode: clientId } });
  }

  getHoldingDataNfo(clientId: any): Observable<any> {
    return this.http.get('/getHoldingsDataNfo', { params: { clientcode: clientId } });
  }

  getHoldingPositions(today: any): Observable<any> {
    return this.http.get('/positions', { params: { as_on_date: today } });
  }

  getHoldingDataMf(date: any): Observable<any> {
    return this.http.get('/getHoldingsDataMf', { params: { as_on_date: date } });
  }

  getHoldingDataCds(clientId: any): Observable<any> {
    return this.http.get('/getHoldingsDataCds', { params: { clientcode: clientId } });
  }

  getHoldingPledge(clientId: any): Observable<any> {
    return this.http.get('/holdingsPledge', { params: { clientcode: clientId } });
  }

  getHoldingUnPledge(clientId: any): Observable<any> {
    return this.http.get('/holdingsRePledgeData', { params: { clientcode: clientId } });
  }

  getHoldingAveragePrice(clientId: any): Observable<any> {
    return this.http.get('/holdingsAvgPrice', { params: { clientcode: clientId } });
  }

  getPledgeRequestData(formData: any): Observable<any> {
    return this.http.post('/pledgeData', formData);
  }

  // submitHoldingPledge(formData: any): Observable<any> {
  //   return this.http.post('/holdingsPledgeInsert', formData);
  // }

  holdingsPledgeInsert(formData: string): Observable<any> {
    return this.http.get('/holdingsPledgeInsert', { params: { scrip_details: formData }});
  }


  submitHoldingUnPledge(formData: any): Observable<any> {
    return this.http.post('/holdingsRepledgeInsert', formData);
  }

  submitHoldingAveragePrice(formData: any): Observable<any> {
    return this.http.post('/holdingsAvgPriceInsert', formData);
  }

  profitAndLossApi(clientId: any): Observable<any> {
    return this.http.get(`/profitAndLossApiChart`, { params: { clientcode: clientId } });
  }

  profitNLossApiEquity(formData: any): Observable<any> {
    return this.http.post(`/profitNLossEq`, formData);
  }

  profitNLossApiFno(formData: any): Observable<any> {
    return this.http.post(`/profitNLossFno`, formData);
  }

  profitNLossApiMcx(formData: any): Observable<any> {
    return this.http.post(`/profitNLossMcx`, formData);
  }

  profitNLossApiCds(formData: any): Observable<any> {
    return this.http.post(`/profitNLossCds`, formData);
  }

  profitNLossApiAll(formData:any):Observable<any> {
    return this.http.post(`/profitNLossAll`,formData);
  }
    profitNLossApiNseCom(formData:any):Observable<any> {
    return this.http.post(`/profitNLossNseCom`,formData);
  }

  profitNLossCharges(formData: any): Observable<any> {
    return this.http.post(`/profitNLossCharges`, formData);
  }

  profitNLossRealised(formData: any): Observable<any> {
    return this.http.post(`/profitNLossRealized`, formData);
  }

  profitNLossUnRealised(formData: any): Observable<any> {
    return this.http.post(`/profitNLossUnRealized`, formData);
  }

  profitNLossSummary(formData: any): Observable<any> {
    return this.http.post(`/profitNLossSummary`, formData);
  }

  getSwotData(formData: any): Observable<any> {
    return this.http.post(`/trendLyne`, formData);
  }

  getEventTradeData(formData: any): Observable<any> {
    return this.http.post(`/tradeCalendarList`, formData);
  }

  getTradewiseTaxPnl(fromDate: any, toDate: any): Observable<any> {
    return this.http.get(`/tradewise-pnl-all`, { params: { from: fromDate, to: toDate } });
  }

  getCumulativePnlAll(fromDate: any, toDate: any): Observable<any> {
    return this.http.get(`/cumulative-pnl-all`, { params: { from: fromDate, to: toDate } });
  }

  getOpenPositionTaxPnl(fromDate: any, toDate: any): Observable<any> {
    return this.http.get(`/open-positions`, { params: { from: fromDate, to: toDate } });
  }

  getHeatmapCalendarData(fromDate: any, toDate: any, segment: any): Observable<any> {
    return this.http.get(`/realised-pnl-heatmap-data`, { params: { from: fromDate, to: toDate, segment: segment } });
  }

  tradebookApi(formData: any): Observable<any> {
    return this.http.post(`/trade-book`, formData);
  }

  tradebookBreakdown(formData: any): Observable<any> {
    return this.http.post(`/trade-book-breakdown`, formData);
  }

  sendBulkMail(formData: any): Observable<any> {
    return this.http.post(`/bulk-email`, formData);
  }

  getTagsHoldingsUpdate(formData: any): Observable<any> {
    return this.http.post('/tagsHoldingsUpdate', formData);
  }

  getTagsCreate(formData: any): Observable<any> {
    return this.http.post('/tagsCreate', formData);
  }

  // getTagsAnalyse(clientId: any): Observable<any> {
  //   return this.http.get('/tagsAnalysis', { params: { client_id: clientId } });
  // }

  getTagsAnalyse(formData: any): Observable<any> {
    return this.http.post('/tagsAnalysis', formData);
  }

  getGenerateDocument(params: any): Observable<any> {
    return this.http.get(`/digitalDocumentGenerate`, { params: params });
  }

  // getHoldingbreakdown(params:any):Observable<any> {
  //   return this.http.get(`/getHoldingsBreakdown`, {params: params });
  // }

  // getHoldingbreakdown(params:any,clientid:any):Observable<any> {
  //   return this.http.get(`/getHoldingsBreakdown`, {
  //     params: {
  //       isin: params,
  //       family_client_id: clientid
  //     }
  //   });
  //   // return this.http.get(`/getHoldingsBreakdown`, {params: { isin : params }});
  // }
  getHoldingbreakdown(params: any, clientid: any): Observable<any> {
    const httpParams: any = {
        isin: params
    };
    if (clientid) {
        httpParams.family_client_id = clientid;
    }
    return this.http.get(`/getHoldingsBreakdown`, { params: httpParams });
}

  getHoldingxirr(params: any):Observable<any> {
    return this.http.get(`/getHoldingsXirr`, {params: params });
  }

  getHoldingXirrMf(clientid: any):Observable<any> {
    const httpParams: any = {
      client_id:clientid
  };
    return this.http.get(`/getXirrMf`,{params:httpParams});
  }

  getHoldingBreakMf(params:any, clientid: any,xirr:any):Observable<any> {
    const httpParams: any = {
      isin: params,
      client_id:clientid,
      xirr:xirr

  };
    return this.http.get(`/getHoldingsBreakdownMf`,{params:httpParams});
  }

  // offmarket

  getOffmarketdata(params:any):Observable<any> {
    return this.http.post('/offMarketData',params);
  }

  // pledge holdingholiday

  getHoliday(params:any):Observable<any> {
    return this.http.get('/holidayData', {params: params });
  }

  getPledegetime():Observable<any> {
    return this.http.get('/holdingsPledgeTimings');
  }

  getGenerateDividentDocument(params: any): Observable<any> {
    return this.http.get(`/dividendReportGenerate`, { params: params });
  }


  // trade journal
  getTradeJournal(params: any):Observable<any> {
    return this.http.post('/traders-journal', params)
  }

  getTradeJournalDetails(params: any):Observable<any> {
    return this.http.post('/traders-journal-data', params)
  }

  getTradeJournalBreakdown(params: any):Observable<any> {
    return this.http.post('/traders-journal-breakdown', params)
  }

}
